import { Training } from '@/domain/trainings/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Stack } from '@andritzot/metris-web-ui/layout/stack';
import { Fragment } from 'react/jsx-runtime';

interface TrainingContentProps {
  productTrainings: Training[];
}

export const TrainingContent = ({ productTrainings }: TrainingContentProps) => {
  return (
    <Box sx={{ m: 2 }}>
      {[...productTrainings]
        ?.sort((a, b) => a.courseOrder - b.courseOrder)
        .map((training) => (
          <Fragment key={training.idTraining}>
            <Typography variant="cardHeading">{training.courseName}</Typography>
            <Stack direction="column" spacing={2} sx={{ ml: 2 }}>
              <Box component="ul" sx={{ pl: 2 }}>
                {training.link && (
                  <Box component="li">
                    <Typography variant="body2">
                      <Box
                        component="a"
                        href={training.link}
                        target="_blank"
                        rel="noreferrer"
                        sx={{ cursor: 'pointer' }}
                      >
                        Link
                      </Box>
                    </Typography>
                  </Box>
                )}
                {training.description && (
                  <Box component="li">
                    <Typography variant="body2">{training.description}</Typography>
                  </Box>
                )}
              </Box>
            </Stack>
          </Fragment>
        ))}
    </Box>
  );
};
